import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection = ({ desktopImage, mobileImage, title, description, ctaText, ctaLink }) => {
  return (
    <section className="hero-section">
      <picture>
        <source media="(max-width: 768px)" srcSet={mobileImage} />
        <img 
          src={desktopImage} 
          alt="Hero" 
          className="hero-image"
        />
      </picture>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-large" dangerouslySetInnerHTML={{ __html: title }} />
        <p className="body-large">
          {description}
        </p>
        <Link 
          to={ctaLink} 
          className="btn-primary"
          style={{
            background: 'var(--burgundy)',
            color: '#fff',
            border: '2px solid var(--burgundy)',
            fontWeight: '700',
            letterSpacing: '1px',
            boxShadow: '0 4px 20px rgba(92, 64, 51, 0.4)',
            fontSize: '15px'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'transparent';
            e.target.style.color = '#fff';
            e.target.style.border = '2px solid #fff';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'var(--burgundy)';
            e.target.style.color = '#fff';
            e.target.style.border = '2px solid var(--burgundy)';
          }}
        >
          {ctaText}
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
